<template>
  <div class="col">
    <h6
      @click="show = !show"
      class="footer-link-title fs-4 fw-bold justify-content-between d-flex"
    >
      <span>{{ $t(title) }}</span>
      <font-awesome-icon class="d-md-none" :icon="['fas', 'chevron-down']" />
    </h6>
    <ul
      class="list-unstyled d-md-block"
      :class="{ 'd-block': show, 'd-none': !show }"
    >
      <li
        class="mb-2"
        v-for="(link, index) in links"
        :key="getLinkKey(link, index)"
      >
        <font-awesome-icon :icon="['fas', 'angle-double-right']" />
        <link-wrapper
          class="ms-2 link-text text-secondary text-decoration-none"
          :location="resolveLocation(link.location)"
          v-bind="link.args || {}"
        >
          {{ $t(link.name) }}
        </link-wrapper>
      </li>
    </ul>
  </div>
</template>

<script>
import LinkWrapper from "../LinkWrapper/LinkWrapper.vue";
export default {
  components: { LinkWrapper },
  props: {
    title: {
      type: String,
      required: true,
    },
    links: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    getLinkKey(link, index) {
      if (!link) {
        return `link-${index}`;
      }
      const location = link.location;
      if (location && typeof location === "object" && location.name) {
        return `${location.name}-${index}`;
      }
      if (typeof location === "string" && location.length) {
        return `${location}-${index}`;
      }
      if (link.name) {
        return `${link.name}-${index}`;
      }
      return `link-${index}`;
    },
    resolveLocation(location) {
      if (location && typeof location === "object") {
        return { ...location };
      }
      if (typeof location === "string" && location.length) {
        return location;
      }
      return "/";
    },
  },
};
</script>

<style scoped>
  .footer-link-title {
    margin: 0 0 19px !important;
    color: white;
  }

  .link-text {
    color: #afafaf !important;
  }
  .link-text:hover {
    color: var(--primary-color) !important;
  }
</style>
